import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  createNewCourse: {
    id: "course-authoring.studio-home.new-course.title",
    defaultMessage: "Crear nuevo curso",
  },
});

export default messages;
